(() => {
  const src = document.querySelector(".linked_products .linked_product");
  if (!src) return;

  const tpl = src.cloneNode(true);
  tpl.classList.remove('hidden');

  const inject = () => {
    const fs = document.querySelector('fieldset');
    if (fs && !fs.querySelector('.linked_product')) fs.appendChild(tpl.cloneNode(true));
  };

  inject();

  const scope = document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]') || document.body;
  new MutationObserver(inject).observe(scope, { childList: true, subtree: true });
})();